import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class AlphaNumericValidator {
  constructor() {}

  alphaNumericValidator(
    formField: AbstractControl
  ): { [key: string]: any } | null | void {
    
    // console.log('Form Field Value: ', formField.value);
    
    // Check if field is Required
    const isEmpty = (formField.value === '') || (formField.value === null) || (formField.value === undefined);
    // if (isEmpty) {
    //   return { required: { valid: false, value: formField.value } };
    // }
    const incomplete = /INCOMPLETE/.test(formField.value);
    if (incomplete) {
      return { incomplete: { valid: false, value: formField.value } };
    }

    // Must only be letters, numbers, spaces and these symbols '-,',/'
    const isAlphaNumeric = /^$|^[0-9a-zA-Z\:\,\.\'\/\-\s]+$/.test(formField.value);
    // console.log('isAlphaNumeric: ', isAlphaNumeric);
    if (!isEmpty && !isAlphaNumeric) {
      return { notAlphaNumeric: { valid: false, value: formField.value } };
    }
  }
}
